import { createPinia, PiniaVuePlugin } from "pinia";
import Vue from "vue";

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

export default pinia;

export * from "./accumulations";
export * from "./admin";
export * from "./api";
export * from "./auth";
export * from "./autoaddress";
export * from "./cognitoAdmin";
export * from "./dataGroups";
export * from "./dataHitCodes";
export * from "./dataSource";
export * from "./gammaData";
export * from "./gammaWebServices";
export * from "./layout";
export * from "./loading";
export * from "./location";
export * from "./map";
export * from "./measuringTool";
export * from "./orgSettings";
export * from "./precisely";
export * from "./printer";
export * from "./userAdmin";
export * from "./books";
